const filterData = [
  {
    id: 1,
    name: 'All',
  },
  {
    id: 2,
    name: 'Sport',
  },
  {
    id: 3,
    name: 'Music',
  },
  {
    id: 4,
    name: 'Design',
  },
  {
    id: 5,
    name: 'Game',
  },
  {
    id: 6,
    name: 'Live',
  },
  {
    id: 7,
    name: 'Fitness',
  },
  {
    id: 8,
    name: 'Cooking',
  },
  {
    id: 9,
    name: 'Fashion',
  },
  {
    id: 10,
    name: 'Lastest',
  },
  {
    id: 11,
    name: 'MacOS',
  }
];

export default filterData;
